import { GET_ZONA_DETALLE } from '../constants/action_types';

const initialState = {
    isLoading: true,
    zonaMaquinas: []
};

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_ZONA_DETALLE + "_SUCCESS":
        
        return {
            isLoading: false,
            zonaMaquinas: action.payload.data.maquinas
        };

        default:

            return state;
    }

}